var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"filter",attrs:{"src":require("@/assets/img/filter.png")},on:{"click":_vm.handleFilter}})}
var staticRenderFns = []

export { render, staticRenderFns }